export const format = (value: number, code: string) =>
  new Intl.NumberFormat(navigator.language, {
    style: 'currency',
    currency: code,
    currencyDisplay: 'symbol'
  }).format(value);
